import React, { createContext, useContext, useState, ReactNode } from 'react'

// Create a context
type ContextType = {
  loading: boolean
  setLoadingFinished: () => void
  setIsLoading: () => void
  submitting: boolean
  setIsSubmitting: () => void
  setSubmittingFinished: () => void
}

const WizardContext = createContext<ContextType | undefined>(undefined)

// Create a provider component
interface WizardProviderProps {
  children: ReactNode
}

export const WizardProvider: React.FC<WizardProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const setIsLoading = () => setLoading(true)
  const setLoadingFinished = () => setLoading(false)
  const [submitting, setSubmitting] = useState(false)
  const setIsSubmitting = () => setSubmitting(true)
  const setSubmittingFinished = () => setSubmitting(false)

  return (
    <WizardContext.Provider
      value={{
        loading,
        setIsLoading,
        setLoadingFinished,
        submitting,
        setIsSubmitting,
        setSubmittingFinished
      }}
    >
      {children}
    </WizardContext.Provider>
  )
}

// Custom hook to use the context
export const useWizardContext = (): ContextType => {
  const context = useContext(WizardContext)
  if (!context) {
    throw new Error('useWizardContext must be used within a WizardProvider')
  }
  return context
}
